import flatMap from 'lodash/flatMap'
import { DepartmentType } from '../generated/types'
import { ReferralDepartmentFragment } from '../routes/referral/ReferralCategory/ActiveExpertCategories.generated'

// HACK: for referral page "Path Single Select" component
export function getActiveCategoriesFromDepartments({
  departments,
  forceOnlyWinterSportsCategories
}: {
  departments: ReferralDepartmentFragment[]
  forceOnlyWinterSportsCategories: boolean
}) {
  // All categories
  let categories = flatMap(departments, department => department.topLevelCategory.expertCategories)

  const inactiveDepartments = [
    DepartmentType.JET_CHARTERS,
    DepartmentType.JEWELRY,
    DepartmentType.CURATED_INTERNAL,
    DepartmentType.OTHER
  ]

  // HACK: Filter out categories with inactive departments
  categories = categories.filter(
    category => category.department && !inactiveDepartments.includes(category.department.type)
  )

  // HACK: Filter out Winter Sports category from expert categories
  categories = categories.filter(category => category.slug !== 'winter-sports')

  // If we know what expert to refer them to and the department is winter sports we need them to choose between ski and snowboard
  if (forceOnlyWinterSportsCategories) {
    categories = categories.filter(
      category => category.department?.type === DepartmentType.WINTER_SPORTS
    )
  }

  return categories
}

export function doesDeptSupportFreeShipping(departmentType: DepartmentType) {
  return departmentType !== DepartmentType.CYCLING
}
